import moment from "moment";

export const checkPOTYStatus = (tournmentDate, startDate, endDate) => {
  let tournament_date = moment(tournmentDate);
  let reg_start_date = moment(startDate);
  let reg_end_date = moment(endDate);

  let status;

  if (
    reg_start_date.startOf("day").diff(moment().startOf("day"), "days") <= 0
  ) {
    if (reg_end_date.startOf("day").diff(moment().startOf("day"), "days") < 0) {
      if (
        tournament_date.startOf("day").diff(moment().startOf("day"), "days") < 0
      ) {
        status = "completed";
      } else if (
        tournament_date.startOf("day").diff(moment().startOf("day"), "days") ==
        0
      ) {
        status = "in-progress";
      } else if (
        tournament_date.startOf("day").diff(moment().startOf("day"), "days") > 0
      ) {
        status = "registration closed";
      }
    } else if (
      reg_end_date.startOf("day").diff(moment().startOf("day"), "days") > 0
    ) {
      status = "registration open";
    } else {
      status = "registration closed";
    }
  } else if (
    reg_start_date.startOf("day").diff(moment().startOf("day"), "days") > 0
  ) {
    status = "scheduled";
  } else {
    status = "registration open";
  }

  return status;
};
